import Vue from 'vue'
import Router from 'vue-router'

import TheHome from '../views/home'
import TheVideo from '../views/video'
// import TheVideoLists from '../views/video/Lists'

import TheSearch from '../views/search'

import TheContest from '../views/contest/Detail'
import TheContestList from '../views/contest/List'
/*import TheEventVideoListsHeader from '../views/event/VideoListsHeader'
import TheEventVideoListsBody from '../views/event/VideoListsBody'*/

import TheInfo from '../views/info'
import TheInfoList from '../views/info/List'
// import TheInfoListsHeader from '../views/info/ListsHeader'
// import TheInfoListsBody from '../views/info/ListsBody'

import TheStudio from '../views/studio/Detail'
import TheStudioList from '../views/studio/List'
import TheStudioVideo from '../views/studio/Video'
import TheStudioDancer from '../views/studio/Dancer'
import TheStudioStore from '../views/studio/Store'
import TheStudioInfo from '../views/studio/Info'
import TheStore from '../views/store'

import TheDancer from '../views/dancer/Detail'
import TheDancerList from '../views/dancer/List'
import TheDancerVideo from '../views/dancer/Video'
import TheDancerActivity from '../views/dancer/Activity'
import TheDancerActivityDetail from '../views/dancer/ActivityDetail'
/*import TheDancerListsHeader from '../views/dancer/ListsHeader'
import TheDancerListsBody from '../views/dancer/ListsBody'*/

import TheUserNav from '../views/user/Nav'
import TheUserHome from '../views/user/Home'
import TheUserUpdate from '../views/user/Update'
import TheUserAvatar from '../views/user/Avatar'
import TheUserModPhone from '../views/user/ModPhone'
import TheUserSelectMode from '../views/user/SelectMode'
import TheUserBindPsw from '../views/user/BindPsw'
import TheUserModPswByPhone from '../views/user/ModPswByPhone'
import TheUserModPswByPsw from '../views/user/ModPswByPsw'
/*import TheUserCollect from '../views/user/MyCollect'
import TheUserFollow from '../views/user/MyFollow'*/
import TheUserUpload from '../views/user/Upload'
import TheUserUploadNorm from '../views/user/UploadNorm'
import TheUserVideoManage from '../views/user/VideoManage'
import TheUserVideoEdit from '../views/user/VideoEdit'

import TheSpaceHeader from '../views/space/Header'
import TheSpaceHome from '../views/space/Home'
import TheSpaceOpus from '../views/space/Opus'
import TheSpaceLike from '../views/space/Like'
import TheSpaceCollectNav from '../views/space/collect/Nav'
import TheSpaceCollectVideo from '../views/space/collect/Video'
import TheSpaceCollectActivity from '../views/space/collect/Activity'
import TheSpaceCollectInfo from '../views/space/collect/Info'
import TheSpaceSetting from '../views/space/Setting'
import TheSpaceFollowNav from '../views/space/follow/Nav'
import TheSpaceFollowUser from '../views/space/follow/User'
import TheSpaceFollowDancer from '../views/space/follow/Dancer'
import TheSpaceFollowStudio from '../views/space/follow/Studio'
import TheSpaceFans from '../views/space/follow/Fans'

import TheApp from '../views/app/Detail'
import TheUserPrivacyPolicy from '../views/user-privacy/index'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [

        // 首页
        {
            name: 'home',
            path: '/(videos)?',// 可选, 且只匹配数字
            component: TheHome,
            /*children: [
                {
                    name: 'home',
                    path: '',
                    component: TheVideoLists
                },
                {
                    name: 'sortVideo',
                    path: 'video',// 可选, 且只匹配数字
                    component: TheVideoLists
                },
            ],*/
        },

        // 视频详情页
        {
            name: 'video',
            path: '/videos/:id(\\d+)',// 可选, 且只匹配数字
            component: TheVideo,
        },

        // 搜索页
        {
            path: '/search',// 可选, 且只匹配数字
            name: 'search',
            component: TheSearch,
        },

        // 资讯列表
        {
            name: 'infoList',
            path: '/info',// 可选, 且只匹配数字
            component: TheInfoList,
            /*children: [
                {
                    name: 'info',
                    path: '',
                    component: TheInfoListsBody
                },
                {
                    name: 'infoCate',
                    path: '/cate/:cate(\\d+)/infos/(page)?/:page(\\d+)?',// 可选, 且只匹配数字
                    component: TheInfoListsBody
                },
            ],*/
        },



        // 赛事列表页
        {
            name: 'contests',
            path: '/contests',// 可选, 且只匹配数字
            component: TheContestList,
        },
        /*{
            name: 'eventMatch',
            path: '/match/:match(\\d+)/events/(page)?/:page(\\d+)?',// 可选, 且只匹配数字
            component: TheEventLists,
        },*/
        // 赛事视频页
        {
            name: 'contestDetail',
            path: '/contests/:id(\\d+)',// 可选, 且只匹配数字
            component: TheContest,
        },

        // 工作室列表页
        {
            path: '/studios',// 可选, 且只匹配数字
            component: TheStudioList,
        },
        // 工作室详情页
        {
            path: '/studios/:id(\\d+)',// 可选, 且只匹配数字
            component: TheStudio,
            children: [
                {
                    path: '',
                    name: 'studioVideo',
                    component: TheStudioVideo
                },
                {
                    path: '/studios/:id(\\d+)/dancers',
                    name: 'studioDancer',
                    component: TheStudioDancer
                },
                {
                    path: '/studios/:id(\\d+)/stores',
                    name: 'studioStore',
                    component: TheStudioStore
                },
                {
                    path: '/studios/:id(\\d+)/info',
                    name: 'studioInfo',
                    component: TheStudioInfo
                },
            ],
        },
        {
            path: '/stores/:id(\\d+)',// 可选, 且只匹配数字
            component: TheStore,
        },

        {
            path: '/info/:id(\\d+)',// 可选, 且只匹配数字
            component: TheInfo,
        },

        // 舞者列表页
        {
            path: '/dancers',// 可选, 且只匹配数字
            component: TheDancerList,
            /*children: [
                {
                    name: 'dancerList',
                    path: '',
                    component: TheDancerListsBody
                },
                {
                    name: 'dancerCateList',
                    path: '/cate/:cate(\\d+)/dancers/(page)?/:page(\\d+)?',// 可选, 且只匹配数字
                    component: TheDancerListsBody,
                },
            ],*/
        },
        // 舞者详情页
        {
            path: '/dancers/:id(\\d+)',// 可选, 且只匹配数字
            component: TheDancer,
            children: [
                {
                    name: 'dancerVideo',
                    path: '',
                    component: TheDancerVideo
                },
                {
                    name: 'dancerActivity',
                    path: 'activities',// 可选, 且只匹配数字
                    component: TheDancerActivity,
                },
            ],
        },
        // 舞者动态详情页
        {
            path: '/dancers/activities/:id(\\d+)',// 可选, 且只匹配数字
            component: TheDancerActivityDetail,
        },

        // 用户个人中心
        {
            path: '/users',// 可选, 且只匹配数字
            component: TheUserNav,
            children: [
                {
                    path: '',
                    name: 'userHome',
                    component: TheUserHome
                },
                /*{
                    path: 'collect',
                    name: 'userCollect',
                    component: TheUserCollect
                },
                {
                    path: 'follow',
                    name: 'userFollow',
                    component: TheUserFollow
                },*/
                {
                    path: 'update',
                    name: 'userUpdate',
                    component: TheUserUpdate
                },
                {
                    path: 'avatar',
                    name: 'userAvatar',
                    component: TheUserAvatar
                },
                {
                    path: 'phone/modify',
                    name: 'userModPhone',
                    component: TheUserModPhone
                },
                {
                    path: 'select',
                    name: 'userSelectMode',
                    component: TheUserSelectMode
                },
                {
                    path: 'psw/bind',
                    name: 'userBindPsw',
                    component: TheUserBindPsw
                },
                {
                    path: 'psw/modify-phone',
                    name: 'userModPswByPhone',
                    component: TheUserModPswByPhone
                },
                {
                    path: 'psw/modify-psw',
                    name: 'userModPswByPsw',
                    component: TheUserModPswByPsw
                },
                {
                    path: 'upload',
                    name: 'userUpload',
                    component: TheUserUpload
                },
                {
                    path: 'upload/norm',
                    name: 'norm',
                    component: TheUserUploadNorm
                },
                {
                    path: 'manage',
                    name: 'userVideoManage',
                    component: TheUserVideoManage
                },
                {
                    path: 'videos/:id(\\d+)/edit',
                    name: 'userVideoEdit',
                    component: TheUserVideoEdit
                },
            ],
        },
        {
            path: '/spaces/:id(\\d+)',// 可选, 且只匹配数字
            component: TheSpaceHeader,
            children: [
                {
                    name: 'spaceHome',
                    path: '',
                    component: TheSpaceHome
                },
                {
                    name: 'spaceOpus',
                    path: 'opuses',
                    component: TheSpaceOpus,
                },
                {
                    name: 'spaceLike',
                    path: 'likes',
                    component: TheSpaceLike,
                },
                {
                    path: 'collect',
                    component: TheSpaceCollectNav,
                    children: [
                        {
                            name: 'spaceCollectVideo',
                            path: '',
                            component: TheSpaceCollectVideo
                        },
                        {
                            name: 'spaceCollectActivity',
                            path: 'activities',
                            component: TheSpaceCollectActivity,
                        },
                        {
                            name: 'spaceCollectInfo',
                            path: 'info',
                            component: TheSpaceCollectInfo,
                        },
                    ],
                },
                {
                    name: 'spaceSetting',
                    path: 'setting',// 可选, 且只匹配数字
                    component: TheSpaceSetting,
                },
                {
                    path: 'follow',// 可选, 且只匹配数字
                    component: TheSpaceFollowNav,
                    children: [
                        {
                            name: 'spaceFollowUser',
                            path: '',// 可选, 且只匹配数字
                            component: TheSpaceFollowUser,
                        },
                        {
                            name: 'spaceFollowDancer',
                            path: 'dancers',// 可选, 且只匹配数字
                            component: TheSpaceFollowDancer,
                        },
                        {
                            name: 'spaceFollowStudio',
                            path: 'studios',// 可选, 且只匹配数字
                            component: TheSpaceFollowStudio,
                        },
                        {
                            name: 'spaceFans',
                            path: 'fans',
                            component: TheSpaceFans
                        },
                    ],
                },
            ],
        },

        // APP推广页
        {
            path: '/app',
            component: TheApp,
        },
        // 用户隐私政策
        {
            path: '/user-privacy-policies',
            component: TheUserPrivacyPolicy,
        },
        // 所有匹配不到的路由 都重定向至首页
        {
            path: '*',
            redirect: '/',
        },
    ],
    // 模拟原生浏览器回到顶部
    scrollBehavior: (to, from, savedPosition) => savedPosition ? savedPosition : {x: 0, y: 0},
})



// WEBPACK FOOTER //
// ./src/router/index.js